import Vue from 'vue';
import store from '.';
import { Module } from 'vuex';
import { RootState } from '@/types/store';
import wish from '@/router/wish';
import { set } from '@/lib/service/storage';
export interface WishState {
    /** 背景信息 */
    bgInfo: Wish.BgInfo[];
    /** 心愿信息 */
    wishInfo: Wish.WishInfo;
    /** 生成的卡片信息 */
    cardUrl: Wish.CardUrl;
    /** 选好的心愿信息 */
    selectedWishList: Wish.WishInfo;
}
const m: Module<WishState, RootState> = {
    namespaced: true,
    state: () => ({
        bgInfo: [],
        wishInfo: [],
        cardUrl: '',
        selectedWishList: [],
    }),
    getters: {},
    mutations: {
        /** 设置背景信息 */
        setBgInfo(state, bgInfo: Wish.BgInfo[]) {
            state.bgInfo = bgInfo;
        },
        /** 设置心愿信息 */
        setWishInfo(state, wishInfo: Wish.WishInfo) {
            state.wishInfo = wishInfo;
        },
        /** 设置生成的心愿卡的url */
        setCardUrl(state, url: string) {
            state.cardUrl = url;
            set('wishCardUrl', url);
        },
        /** 设置选好的心愿列表 */
        setSelectedWishList(state, selectedWishList) {
            state.selectedWishList = selectedWishList;
            set('selectedWishList', JSON.stringify(selectedWishList));
        },
    },
    actions: {
        /**
         * 获取预设的心愿信息
         */
        async getWishInfo({ commit }) {
            const response = await Vue.axios.get('/api/v1/wish_list/presets');
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setWishInfo', rdata.data.wishes);
            }
            return rdata;
        },
        /**
         * 获取预设的背景信息
         */
        async getBgInfo({ commit }) {
            const response = await Vue.axios.get('/api/v1/wish_list/presets');
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setBgInfo', rdata.data.backgrounds);
            }
            return rdata;
        },
        /**
         * 获取生成的卡片的链接
         */
        async getCardUrl({ commit }, { backgroundId, wishes }: { backgroundId: number, wishes: Wish.WishInfo }) {
            const response = await Vue.axios.post('/api/v1/wish_list/generate_card', {
                background_id: backgroundId,
                wishes,
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setCardUrl', rdata.data.url);
            }
            return rdata;
        },
    },
};
export default m;
